<template>
  <div class="item from-group mb-0" :class="{ failed: error || validateError }">
    <label v-if="label" :for="id" class="block font-bold uppercase mb-1">
      {{ label }}
      <span v-if="required">*</span>
    </label>

    <input
      :id="id"
      :placeholder="placeholder"
      v-bind="$attrs"
      class="form-control"
      :value="modelValue"
      :disabled="true"
      v-if="disabled"
    />
    <VueTelInput
      :inputOptions="{
        placeholder,
        required,
      }"
      defaultCountry="EE"
      :id="id"
      v-bind="$attrs"
      class="form-control"
      :value="modelValue"
      mode="international"
      @input="onInput"
      v-else
    />
  </div>
</template>
<script>
import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import parsePhoneNumber from 'libphonenumber-js/max'
import { ref } from 'vue'

export default {
  name: 'PhoneField',
  inheritAttrs: false,
  components: {
    VueTelInput,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
    allowedTypes: {
      type: Array,
      default: () => {
        return []
      },
    },
    modelValue: String,
  },
  emits: ['update:modelValue', 'updated'],
  setup(props, { emit }) {
    const validateError = ref(false)

    const getPhoneType = (number, country) => {
      const parsed = parsePhoneNumber(number, country)
      return parsed.getType() || null
    }

    const validate = (phoneObject) => {
      if (phoneObject.valid) {
        if (props.allowedTypes.length) {
          const type = getPhoneType(
            phoneObject.nationalNumber,
            phoneObject.countryCode
          )
          if (props.allowedTypes.includes(type)) {
            emit('update:modelValue', phoneObject.number.toString())
            emit('updated', phoneObject.number.toString())
          } else {
            emit('update:modelValue', '')
            emit('updated', '')
          }
        } else {
          emit('update:modelValue', phoneObject.number.toString())
          emit('updated', phoneObject.number.toString())
        }
      } else {
        emit('update:modelValue', '')
        emit('updated', '')
      }

      validateError.value = phoneObject.number && !phoneObject.valid
    }

    const onInput = (value, phoneObject) => {
      if (phoneObject) {
        validate(phoneObject)
      }
    }

    return {
      onInput,
      validateError,
    }
  },
}
</script>

<style lang="scss" scoped>
.form-control {
  display: flex !important;
  box-shadow: none !important;
  border-radius: 0 !important;

  ::v-deep(.vti__dropdown) {
    background-color: transparent;
    padding: 0;
  }

  ::v-deep(.vti__flag) {
    margin: 0;
  }

  ::v-deep(input) {
    background-color: transparent;
    border-radius: 0;

    &:focus {
      outline: none !important;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus textarea:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px #eeeeee inset !important;
    }
  }
}
</style>
